export default __webpack_public_path__ + "images/KJ.d33dde2.png";